// Scenarios Constants
export const SCENARIO_URL = `/api/scenario`;
export const ALL_SCENARIOS_URL = `${SCENARIO_URL}/all_scenarios`;